import { Copy } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

import { cn } from '@/utils';

interface CopyButtonProps {
  value: string;
  label: string;
  className?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ value, label, className }) => (
  <button
    className={cn('p-1 rounded text-muted-foreground hover:bg-muted transition-colors', className)}
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      navigator.clipboard.writeText(value);
      toast.success(`${label} copied to clipboard`);
    }}
    title={`Copy ${label}`}
    type="button"
  >
    <Copy className="w-3.5 h-3.5" />
  </button>
);
